import script from "./insectSection.vue?vue&type=script&setup=true&lang=js"
export * from "./insectSection.vue?vue&type=script&setup=true&lang=js"

import "./insectSection.vue?vue&type=style&index=0&id=10a7021e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10a7021e"]])

export default __exports__